function wfStartTour(tourTarget, fallbackUrl) {
  if (!window.driverJsDriver && window.driver !== undefined)
      window.driverJsDriver = window.driver.js.driver({smoothScroll: true});

  if (!tourTarget)
    var tourTarget = new URLSearchParams(window.location.search).get('wf_tour');
  if (!tourTarget || typeof window.driver === 'undefined' || typeof window.driver.js === 'undefined') return;

  var tours = {
    'experience-tab': {
      element: '[data-tour="experience-tab"]',
      popover: { title: 'Experience tab', description: 'Customize badge text, size, rounding, position, and announcement settings here.' },
      clickFirst: '.wf-movement-navigation-campaign',
      clickFirstLabel: 'Click Memberships to find this setting.'
    },
    'brand-tab': {
      element: '[data-tour="brand-tab"]',
      popover: { title: 'Brand tab', description: 'Set your brand colors here. These apply to your badge and membership page.' },
      clickFirst: '.wf-movement-navigation-campaign',
      clickFirstLabel: 'Click Memberships to find this setting.'
    },
    'enrollment-tasks-tab': {
      element: '[data-tour="enrollment-tasks-tab"]',
      popover: { title: 'Enrollment Tasks', description: 'Set up tasks so your staff knows what to do when a member joins or leaves.' },
      clickFirst: '.wf-movement-navigation-campaign',
      clickFirstLabel: 'Click Memberships to find this setting.'
    },
    'integrations-socials': {
      element: '[data-tour="integrations-socials"]',
      popover: { title: 'Socials', description: 'Add your Facebook Group or Discord so members see a "Come hang out!" link.' },
      clickFirst: '.wf-movement-navigation-integrations',
      clickFirstLabel: 'Click Integrations to find this setting.'
    },
    'integrations-printful': {
      element: '[data-tour="integrations-printful"]',
      popover: { title: 'Printful', description: 'Set up Printful to automatically send merch to members.' },
      clickFirst: '.wf-movement-navigation-integrations',
      clickFirstLabel: 'Click Integrations to find this setting.'
    },
    'add-to-my-website': {
      element: '[data-tour="share-online-website-action"]',
      popover: { title: 'Add to my website', description: 'Choose this to open your website tools, including your embed code and website button assets.' },
      clickFirst: '[data-tour="add-to-my-website"]',
      clickFirstLabel: 'Open Share online.'
    },
    'share-in-store': {
      element: '[data-tour="share-in-store"]',
      popover: { title: 'Share In Store', description: 'Find posters, shelf-talkers, register signs, the Point-of-Sale app, and other in-store materials here.' }
    },
    'share-online': {
      element: '[data-tour="share-online-newsletter-action"]',
      popover: { title: 'Add to my newsletter', description: 'Choose this to open your newsletter tools, including your newsletter blurb and newsletter link options.' },
      clickFirst: '[data-tour="add-to-my-website"]',
      clickFirstLabel: 'Open Share online.'
    },
    'editable-banner': {
      element: '[data-tour="share-online-website-action"]',
      popover: { title: 'Add to my website', description: 'Choose this to open your website tools. After that screen opens, scroll down to Create Custom Banner.' },
      clickFirst: '[data-tour="add-to-my-website"]',
      clickFirstLabel: 'Open Share online.'
    },
    'point-of-sale': {
      element: '[data-tour="share-in-store"]',
      popover: { title: 'Share In Store', description: 'Find posters, shelf-talkers, register signs, the Point-of-Sale app, and other in-store materials here.' }
    },
    'create-event': {
      element: '[data-tour="create-event"]',
      popover: { title: 'Create Event', description: 'Add an event to Withfriends. Every event automatically upsells memberships at checkout.' },
      clickFirst: '.wf-movement-navigation-events',
      clickFirstLabel: 'Click Events to find this setting.'
    },
    'connect-eventbrite': {
      element: '[data-tour="connect-eventbrite"]',
      popover: { title: 'Connect Eventbrite', description: 'Use this button to connect your Eventbrite account. If it is already connected, this is where you manage it.' },
      clickFirst: '.wf-movement-navigation-events',
      clickFirstLabel: 'Click Events to find this setting.'
    },
    'events-tab': {
      element: '[data-tour="connect-eventbrite"]',
      popover: { title: 'Events', description: 'This is the Events area. Use this section to connect or manage Eventbrite, and create Withfriends events.' },
      clickFirst: '.wf-movement-navigation-events',
      clickFirstLabel: 'Click Events to find this setting.'
    },
    'events-page': {
      element: '[data-tour="events-page"]',
      popover: { title: 'Your Events Page', description: 'This is your public events page. Share this link in your website nav and social bios.' },
      clickFirst: '.wf-movement-navigation-events',
      clickFirstLabel: 'Click Events to find this setting.'
    }
  };

  var step = tours[tourTarget];
  if (!step) return;

  // If element isn't in the DOM yet, highlight the tab for the user to click
  if (step.clickFirst && !document.querySelector(step.element)) {
    var tab = document.querySelector(step.clickFirst);
    if (tab) {
      driverJsDriver.highlight({
        element: step.clickFirst,
        popover: { title: step.clickFirstLabel, showButtons: [] }
      });
      // When user clicks the tab, dismiss highlight and wait for target to load
      tab.addEventListener('click', function onTabClick() {
        tab.removeEventListener('click', onTabClick);
        fadeOutThenDo(function() { pollForElement(step); });
      }, { once: true });
      return;
    }
  }

  pollForElement(step, fallbackUrl);
}

function fadeOutThenDo(callback) {
  var overlay = document.querySelector('.driver-overlay');
  var popover = document.querySelector('.driver-popover');
  var els = [overlay, popover].filter(Boolean);
  if (!els.length) { driverJsDriver.destroy(); if (callback) callback(); return; }
  els.forEach(function(el) {
    el.style.transition = 'opacity 0.3s ease';
    el.style.opacity = '0';
  });
  setTimeout(function() { driverJsDriver.destroy(); if (callback) callback(); }, 300);
}

function fadeOutAndDestroy() {
  fadeOutThenDo();
}

function pollForElement(step, fallbackUrl) {
  var attempts = 0;
  var poll = setInterval(function() {
    attempts++;
    var el = document.querySelector(step.element);
    if (el) {
      clearInterval(poll);
      driverJsDriver.highlight(step);
      el.addEventListener('click', function() {
        fadeOutAndDestroy();
      }, { once: true });
    } else if (attempts > (fallbackUrl ? 4 : 20)) {
      clearInterval(poll);
      if (fallbackUrl) window.location.href = fallbackUrl;
    }
  }, 250);
}

if (document.readyState === 'complete') {
  wfStartTour();
} else {
  window.addEventListener('load', () => wfStartTour());
}
